import AccessibilityNav from '../plugins/AccessibilityNavPlugin';

export default function initAccessibilityNav() {
  document.querySelectorAll('.nav-menu').forEach((nav) => {
    // Initialize accessibility navigation
    const accessibilityNav = new AccessibilityNav(nav, '1280px');

    if (!('ontouchstart' in window)) {
      // Handle focus events for sub-menu items
      const showMenuLinks = nav.querySelectorAll('.show-sub-menu > a');
      showMenuLinks.forEach((link) => {
        // Check if device is not touch-enabled

        link.addEventListener('focus-triggered', function (e) {
          if (window.matchMedia('(min-width: 1280px)').matches) {
            // Remove hover-desktop class from all links
            showMenuLinks.forEach((l) => l.parentElement.classList.remove('hover-desktop'));
            // Add class to focused link
            this.parentElement.classList.add('hover-desktop');
          }
        });

        // Clear hover-desktop class on blur
        link.addEventListener('blur-triggered', function (e) {
          if (window.matchMedia('(min-width: 1280px)').matches) {
            setTimeout(() => {
              if (!nav.contains(document.activeElement)) {
                this.parentElement.classList.remove('hover-desktop');
              }
            }, 50);
          }
        });
      });

      // Handle top-level menu interactions

      const topLevelItems = nav.querySelectorAll('.nav-menu > li');
      topLevelItems.forEach((menuItem) => {
        const subMenu = menuItem.querySelector('.show-sub-menu');
        if (!subMenu) return;

        // Use MediaQueryList for consistent behavior
        const mediaQuery = window.matchMedia('(min-width: 1280px)');

        const handleMediaChange = (e) => {
          if (e.matches) {
            // Desktop behavior
            menuItem.addEventListener('mouseenter', handleMouseEnter);
            menuItem.addEventListener('mouseleave', handleMouseLeave);
          } else {
            // Mobile behavior
            menuItem.removeEventListener('mouseenter', handleMouseEnter);
            menuItem.removeEventListener('mouseleave', handleMouseLeave);
          }
        };

        function handleMouseEnter(e) {
          if (menuItem.classList.contains('accessibility-hover')) {
            subMenu.classList.add('accessibility-hover');
          }
        }

        function handleMouseLeave(e) {
          subMenu.classList.remove('accessibility-hover');
        }

        // Initial check
        mediaQuery.addEventListener('change', handleMediaChange);
        handleMediaChange(mediaQuery);
      });
    }
  });
}
